import { EventRepository } from '~repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import { Event } from '~entities/Event';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';

export class AppointmentDateTimeSelectedUseCase {
    private eventRepository: EventRepository;
    private dateTime: string;

    constructor(dateTime: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.dateTime = dateTime;
    }

    public execute = async () => {
        const appointmentDateTimeSelectedPayload = {
            event_name: 'appointment booking',
            event_category: 'appointment booking',
            event_action: 'date and time selected',
            event_label: this.dateTime
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_DATE_TIME_SELECTED,
            type: 'link',
            payload: appointmentDateTimeSelectedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
